import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockCopyPasteDirective } from '@shared/utility/block-copy-paste.directive';

@NgModule({
  declarations: [BlockCopyPasteDirective],
  imports: [CommonModule],
  exports: [BlockCopyPasteDirective],
})
export class CopyAndPasteModule {}
